import { useState, useEffect } from 'react';
import type { Size } from '../types';

/**
 * Track the dimensions of the browser window.
 * @example
 * const { width: windowWidth, height: windowHeight } = useWindowSize()
 */
export function useWindowSize() {
  const [windowSize, setWindowSize] = useState<Size>({
    width: 0,
    height: 0,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
}
